<template>
  <div class="rewards" >
    <!--按钮显示-->
    <div class="launcher" @click="panelBodyShow" :class="panelBody?'min_width':'max_width'">
      <div class="launcher-button" >
        <div
          class="launcher-container background-primary smile-launcher-font-color-light smile-launcher-border-radius-circular smile-launcher-image-only" :class="panelBody?'launcher-open':'launcher-closed'">
          <div class="launcher-content-container">
            <svg-icon slot="prefix" fill="#fff" icon-class="present" class="present"/>
            <div class="launcher-text">
              <span>{{ $t('rewards') }}</span>
            </div>
          </div>
          <svg-icon slot="prefix" fill="#fff" icon-class="present" class="present"/>
          <div class="launcher-close-icon close-btn"></div>
        </div>
      </div>
    </div>
    <!--end按钮显示-->
    <div :class="panelBody?'':'out'"  >
    <transition name="bounce" enter-active-class="bounceInLeft" leave-active-
                class="bouceOutRight">
        <div class="smile-panel-frame-container" v-if="panelBody"  >
        <div class="panel-body">
          <div
            class="panel-wrapper smile-theme-light smile-banner-font-color-light smile-collapsed-banner-font-color-light smile-panel-card-border-radius-rounded smile-button-border-radius-rounded smile-input-border-radius-rounded smile-button-font-color-light accessibility-nav-mouse">
            <div class="main-panel-container">
              <div class="panel-header-container" :class="[jump?'':'collapsed',joinNum>0?'':'expanded-header']">
                <div class="panel-fixed-header">
                  <div class="d-flex align-items-center header-content flex-truncate">
                    <div @click="toEarn(0)" v-show="joinNum>0" class="chevron-btn panel-header-icon"></div>
                    <div class="ml-2 flex-truncate">
                      <div class="text-truncate">New Biotech</div>
                      <div class="caption"></div>
                    </div>
                  </div>
                  <button class="close-btn panel-header-icon" aria-label="Close" @click="panelBodyShow"></button>
                </div>
                <div class="panel-expanded-header background-gradient" :class="jump?'with-transition':'with-transition'"
                     :style="jump?'':'transform: translate3d(0, -140px, 0)'">
                  <div class="banner-content" :style="jump?'':'opacity: 1;'">
                    <div class="header-icon"></div>
                    <div class="header-secondary heading text-truncate">{{ $t('welcomeTo') }}</div>
                    <div class="header-primary display text-truncate" style="font-size: 32px;">New Biotech</div>
                  </div>
                </div>
              </div>
              <div class="panel-container with-smile-footer" @scroll="myFunction($event)">
                <div v-show="joinNum===0" class="home-view-container">
                  <div class="panel-card-container join-program-card-container">
                    <div class="join-program-card text-center">
                      <div class="heading mb-5 pt-2">{{ $t('becomeMember') }}</div>
                      <div class="card-description text-prewrap">{{ $t('moreWays') }}
                      </div>
                      <a class="btn btn-primary mb-4" href="#">{{ $t('joinNow') }}</a>
                      <div class="body-1 mb-2">{{ $t('alreadyHaveAccount') }}&nbsp;<a href="#">{{ $t('signIn') }}</a></div>
                    </div>
                  </div>
                  <div class="panel-card-container points-explainer-card-container">
                    <div class="points-explainer-card">
                      <div class="heading mb-5 pt-2 text-center">{{ $t('points') }}</div>
                      <div class="card-description text-center">{{ $t('earnMorePoints') }}
                      </div>
                      <div class="card-list-container ">

                        <div class="card-list-item-container ">
                          <button @click="toEarn(1)" class="card-list-item " aria-label="Ways to earn">
                            <div class="card-list-item-content"><img class="list-item-image" alt=""
                                                                     src="https://cdn.sweettooth.io/v1/images/earn-more-points.svg?color=%23ffc575&amp;theme=light">
                              <div class="list-item-text-wrapper">
                                <div class="list-item-title">{{ $t('waysToEarn') }}</div>
                              </div>
                            </div>
                            <div class="chevron right" ></div>
                          </button>
                        </div>

                        <div class="card-list-item-container ">
                          <button @click="toEarn(2)" class="card-list-item " aria-label="Ways to spend">
                            <div class="card-list-item-content"><img class="list-item-image" alt=""
                                                                     src="https://cdn.sweettooth.io/v1/images/spend-your-points.svg?color=%23ffc575&amp;theme=light">
                              <div class="list-item-text-wrapper">
                                <div class="list-item-title">{{ $t('waysToSpend') }}</div>
                              </div>
                            </div>
                            <div class="chevron right"></div>
                          </button>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="panel-card-container referrals-explainer-card-container">
                    <div class="referrals-explainer-card">
                      <div class="heading mb-5 pt-2 text-center">{{ $t('referrals') }}</div>
                      <div class="card-description text-center">{{ $t('giveFriends') }}
                      </div>
                      <div class="card-list-container">
                        <div class="card-list-item no-hover">
                          <div class="card-list-item-content"><img class="list-item-image" alt=""
                                                                   src="https://cdn.sweettooth.io/v1/images/rewards/fixed-amount.svg?color=%23ffc575&amp;theme=light">
                            <div class="list-item-text-wrapper">
                              <div class="list-item-title">{{ $t('theyGet') }}</div>
                              <div class="list-item-subtitle text-muted">{{ $t('5discount') }}</div>
                            </div>
                          </div>
                        </div>
                        <div class="card-list-item no-hover">
                          <div class="card-list-item-content"><img class="list-item-image" alt=""
                                                                   src="https://cdn.sweettooth.io/v1/images/rewards/fixed-amount.svg?color=%23ffc575&amp;theme=light">
                            <div class="list-item-text-wrapper">
                              <div class="list-item-title">{{ $t('youGet') }}</div>
                              <div class="list-item-subtitle text-muted">{{ $t('5discount') }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="joinNum===1" class="panel-subview">
                  <div class="card-heading-container ">
                    <div class="card-title heading ">{{ $t('waysToEarn') }}
                    </div>
                    <div class="card-list-container">
                      <div class="card-list-item-container">
                        <div class="card-list-item no-hover">
                          <div class="card-list-item-content">
                            <img class="list-item-image" alt="" src="https://cdn.sweettooth.io/v1/images/earning/order-online.svg?color=%23ffc575&amp;theme=light">
                            <div class="list-item-text-wrapper">
                              <div class="list-item-title">{{ $t('placeOrder') }}</div>
                              <div class="list-item-subtitle text-muted">{{ $t('5points') }}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="card-list-item-container">
                        <div class="card-list-item no-hover">
                          <div class="card-list-item-content">
                            <img class="list-item-image" alt="" src="https://cdn.sweettooth.io/v1/images/earning/signup.svg?color=%23ffc575&amp;theme=light">
                            <div class="list-item-text-wrapper">
                              <div class="list-item-title">{{ $t('placeOrder') }}</div>
                              <div class="list-item-subtitle text-muted">{{ $t('5points') }}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="card-list-item-container">
                        <div class="card-list-item no-hover">
                          <div class="card-list-item-content">
                            <img class="list-item-image" alt="" src="https://cdn.sweettooth.io/v1/images/earning/birthday.svg?color=%23ffc575&amp;theme=light">
                            <div class="list-item-text-wrapper">
                              <div class="list-item-title">{{ $t('placeOrder') }}</div>
                              <div class="list-item-subtitle text-muted">{{ $t('5points') }}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div v-show="joinNum===2" class="panel-subview">
                  <div class="card-heading-container ">
                    <div class="card-title heading ">{{ $t('waysToEarn') }}
                    </div>
                    <div class="card-list-container">

                      <div class="card-list-item-container">
                        <div class="card-list-item no-hover">
                          <div class="card-list-item-content">
                            <img class="list-item-image" alt="" src="https://cdn.sweettooth.io/v1/images/rewards/fixed-amount.svg?color=%23ffc575&amp;theme=light">
                            <div class="list-item-text-wrapper">
                              <div class="list-item-title">$6 {{ $t('offDiscount') }}</div>
                              <div class="list-item-subtitle text-muted">600 {{ $t('points') }}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="card-list-item-container">
                        <div class="card-list-item no-hover">
                          <div class="card-list-item-content">
                            <img class="list-item-image" alt="" src="https://cdn.sweettooth.io/v1/images/rewards/fixed-amount.svg?color=%23ffc575&amp;theme=light">
                            <div class="list-item-text-wrapper">
                              <div class="list-item-title">$10 {{ $t('offDiscount') }}</div>
                              <div class="list-item-subtitle text-muted">1000 {{ $t('points') }}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="card-list-item-container">
                        <div class="card-list-item no-hover">
                          <div class="card-list-item-content">
                            <img class="list-item-image" alt="" src="https://cdn.sweettooth.io/v1/images/rewards/fixed-amount.svg?color=%23ffc575&amp;theme=light">
                            <div class="list-item-text-wrapper">
                              <div class="list-item-title">$20 {{ $t('offDiscount') }}</div>
                              <div class="list-item-subtitle text-muted">2000 {{ $t('points') }}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel-footer">
              <div class="powered-by-container">
                <div class="powered-by-smile-icon mr-2"></div>
                <div class="powered-by-text">
                  <a class="powered-by-link" href="" target="_blank" rel="noopener noreferrer">{{ $t('rewardSmile') }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "rewards",
  data() {
    return {
      panelBody: false,
      jump: true,
      scroll: 0,//监听滚动条的值
      joinNum:0,//去哪页面
      scrollNum:false,//跳转不运行
    }
  },
  methods: {
    //页面展示
    panelBodyShow() {
      this.panelBody = !this.panelBody;
      console.log(this.panelBody)
    },
    //顶部导航变化
    myFunction(event) {
      if (!this.scrollNum){
        var scrollTop = event.target.scrollTop;
        scrollTop > 13 ? this.jump = false : this.jump = true;
        console.log("跳转之后",scrollTop,this.jump)
      }
    },
    //点击转换页面
    toEarn(num){
      this.joinNum = num;
      this.jump =false;
      if (num===0){
        this.scrollNum =false;
        this.jump =true;
      }else{
        this.scrollNum =true;
      }
    }
  },
  mounted() {
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/rewards.less";
</style>



// WEBPACK FOOTER //
// src/components/rewards.vue